export const getRandomPastelColor = () => {
  const hue = Math.floor(Math.random() * 360);
  // High saturation (70-100%) and high lightness (80-90%) creates pastel look
  return `hsl(${hue}, 70%, 85%)`;
};